import React from 'react'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export function ArticlePreviewSkeleton() {
  return (
    <div className="h-full flex flex-col bg-background">
      {/* Header Skeleton */}
      <div className="border-b bg-background">
        <div className="max-w-6xl mx-auto px-4 flex items-center justify-between py-4">
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-32" />
            <div className="h-6 w-px bg-border" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-16" />
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-8" />
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="flex-1 flex overflow-hidden">
        {/* Left Side - Article Preview Skeleton */}
        <div className="flex-1 min-w-0 overflow-hidden">
          <div className="px-4 py-8">
            <div className="max-w-6xl mx-auto">
              {/* Stats Bar Skeleton */}
              <div className="flex items-center justify-between mb-8 p-4 rounded-lg bg-muted/20 border">
                <div className="flex items-center gap-6">
                  <Skeleton className="h-4 w-20" />
                  <div className="h-4 w-px bg-border" />
                  <Skeleton className="h-4 w-24" />
                  <div className="h-4 w-px bg-border" />
                  <Skeleton className="h-4 w-16" />
                </div>
              </div>

              {/* Article Content Skeleton */}
              <div className="space-y-6">
                {/* Title */}
                <div className="text-center mb-8">
                  <Skeleton className="h-12 w-3/4 mx-auto mb-4" />
                  <Skeleton className="h-6 w-1/2 mx-auto mb-6" />
                  <div className="flex items-center justify-center gap-6">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-4 w-28" />
                  </div>
                </div>

                {/* Featured Image */}
                <div className="mb-8">
                  <Skeleton className="w-full h-64 rounded-xl" />
                </div>

                {/* Content Paragraphs */}
                <div className="space-y-4">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                  <div className="h-4" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-2/3" />
                  <div className="h-4" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-4/5" />
                </div>

                {/* More content blocks */}
                <div className="space-y-4 mt-8">
                  <Skeleton className="h-6 w-1/3" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Details Sidebar Skeleton */}
        <div className="w-80 border-l bg-background overflow-hidden flex flex-col">
          <div className="p-4 border-b bg-background">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-8 w-8" />
            </div>
          </div>
          <div className="p-4 space-y-4">
            {/* Content Score Skeleton */}
            <div className="bg-background/80 border rounded-lg p-4 shadow-sm">
              <div className="flex items-center justify-between mb-3">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-8 w-16 rounded-full" />
              </div>
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-3/4 mt-1" />
            </div>

            {/* Keywords Skeleton */}
            <div className="bg-background/80 border rounded-lg p-3 shadow-sm">
              <div className="flex items-center gap-2 mb-3">
                <Skeleton className="h-3 w-3" />
                <Skeleton className="h-4 w-16" />
              </div>
              <div className="space-y-2">
                <div>
                  <Skeleton className="h-3 w-12 mb-1" />
                  <Skeleton className="h-6 w-24 rounded-full" />
                </div>
                <div>
                  <Skeleton className="h-3 w-16 mb-1" />
                  <div className="flex gap-1">
                    <Skeleton className="h-5 w-16 rounded-full" />
                    <Skeleton className="h-5 w-20 rounded-full" />
                  </div>
                </div>
              </div>
            </div>

            {/* Meta Info Skeleton */}
            <div className="bg-background/80 border rounded-lg p-3 shadow-sm">
              <div className="flex items-center gap-2 mb-3">
                <Skeleton className="h-3 w-3" />
                <Skeleton className="h-4 w-24" />
              </div>
              <div className="space-y-2">
                <div>
                  <Skeleton className="h-3 w-8 mb-1" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-3 w-12 mt-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
